import util from 'bootstrap';

$(document).on('shown.bs.tab', 'a[data-toggle="tab"]', function (e) {
    $('.nav-link').not(this).removeClass('active');
    e.preventDefault();
});

$(document).on('shown.bs.tab', 'a.nav-link-mob', function (e) {
    var href = $(this).attr('href');
    $('html, body').animate({
        scrollTop: $(href).offset().top - 200
    }, 'slow');
    e.preventDefault();
});